<template>
<div :class="`c-gallery-image-scroller-small ${(controlsLiveRegion) ? 'c-gallery-image-scroller-small--controls-live-region' : ''}`" ref="thumbnailWrapper">
    <div class="c-gallery-image-scroller-small__image-row">
        <div class="c-gallery-image-scroller-small__thumbnails" ref="thumbnails">
            <template v-for="(image, index) in images.slice(0, ((images.length > 5 && !showAll) ? 5 : images.length))">
                <component 
					:is="'button'"
					:type="'button'" 
					:aria-pressed="controlsLiveRegion ? currentIndex === index : undefined" 
					:class="`c-gallery-image-scroller-small__thumbnail-button ${(controlsLiveRegion && currentIndex === index) ? 'c-gallery-image-scroller-small__thumbnail-button--current' : ''}`" 
                    :id="image.id" 
					:href="(isLinks) ? image.href : undefined"
                    :key="index"
					@click="selectImage(index, image.id)">
                    <img class="c-gallery-image-scroller-small__thumbnail" :src="!image.imageUrl && image.iframeType === 'vr' ? '../../../placeholders/images/gallery/exiframe2.jpg' : !image.imageUrl && image.iframeType === 'video' ? '../../../placeholders/images/gallery/exiframe1.jpg' : image.imageUrl" :alt="image.text" :title="image.text" />
                    <div class="c-gallery-immage-scroller-small-iframe" v-if="image.iframe">
                        <v-icon v-if="image.iframeType === 'video'" name="icon-play" :cssModifiers="'c-icon--white c-list__icon c-icon--scale-big'" />
                        <v-icon v-if="image.iframeType === 'vr'" name="icon-360deg" :cssModifiers="'c-icon--white c-list__icon c-icon--lg c-icon--padding'" />
                    </div>
                </component>
            </template>
            <template v-if="images.length > 5 && !showAll">
                <button @click="toggleShowAll" class="c-gallery-image-scroller__thumbnail-button--moreimg">+{{images.length - 5}} fler</button>
            </template>
        </div>
    </div>
</div>
</template>

<script>
import VIcon from '../icon/VIcon.vue';


export default {
    name: 'VGalleryImageScrollerSmall',
    components: {
        VIcon,
    },
    props: {
        controlsLiveRegion: {
            type: Boolean,
            default: false
        },
		isLinks: {
			type: Boolean,
			default: false
		},
        images: {
            type: Array,
            default: () => []
        },
        thumbnailWidth: {
            type: Number,
            default: 21
        },
		minNumToShow: {
			type: String,
			default: "1"
		}
    },
    data() {
        return {
            currentIndex: 0,
            showAll: false,
        }
    },
    computed: {
        thumbnailCss() {
            return 'flex:0 0 ' + this.thumbnailWidth + '%';
        }
    },
    methods: {
        selectImage(index, id) {
            this.currentIndex = index;
            this.$emit('selectImage', index, id);
        },
        toggleShowAll() {
            this.showAll = !this.showAll;
        },
    },
    mounted: function () {}
}
</script>
